// extracted by mini-css-extract-plugin
export default {"mid-box":"NonContactMedicalCover_mid-box__futeF","top":"NonContactMedicalCover_top__rkKNW","botm":"NonContactMedicalCover_botm__vc5Bf"};